module.exports = __webpack_public_path__ + "static/media/Pack4.3e4a8f78.jpg";